/**
 * StarSong Natal Wheel v5.2
 * ──────────────────────────────────────────────────────────────
 * Zodiac sign glyphs: Astroline-style filled SVG paths.
 * Planet glyphs: Astroline-style filled SVG paths (Uranus/Neptune stroked fallback).
 * Zero unicode, zero emoji.
 */
(function(global) {
  'use strict';

  /* ══════════════════════════════════════════════════════════════
     ZODIAC SIGN GLYPHS — filled paths (Astroline-style)
     Order: Aries(0) → Pisces(11).  {d, w, h} = native bbox.
     ══════════════════════════════════════════════════════════════ */
  var SIGN_DATA = [
    /* 0 Aries */ { w:11.35,h:9.18, d:'M10.63,1.32C9.78,0.2 8.28,-0.28 6.96,0.16C6.4,0.35 5.94,0.69 5.61,1.14C5.28,0.73 4.85,0.42 4.32,0.24C3,-0.2 1.5,0.28 0.65,1.4C-0.17,2.49 -0.07,3.51 0.17,4.18C0.43,4.91 1.01,5.62 1.45,5.73C1.79,5.81 2.15,5.62 2.24,5.27C2.32,4.97 2.16,4.66 1.89,4.53C1.78,4.43 1.4,4.02 1.31,3.44C1.24,3 1.37,2.58 1.68,2.17C2.19,1.5 3.13,1.21 3.91,1.47C4.61,1.7 4.99,2.33 4.99,3.24L4.99,8.46L4.99,8.54C4.99,8.9 5.28,9.18 5.64,9.18C6,9.18 6.29,8.9 6.29,8.54L6.29,8.46L6.29,3.24L6.29,3.16C6.29,2.25 6.67,1.62 7.37,1.39C8.15,1.13 9.09,1.42 9.6,2.09C9.91,2.5 10.03,2.92 9.96,3.36C9.87,3.94 9.49,4.36 9.38,4.45C9.11,4.58 8.96,4.89 9.04,5.19C9.13,5.54 9.48,5.74 9.83,5.65C10.27,5.54 10.85,4.83 11.11,4.1C11.35,3.43 11.45,2.41 10.63,1.32z' },
    /* 1 Taurus */ { w:9.92,h:9.85, d:'M2.63,6.11C2.63,7.46 3.72,8.58 5.04,8.58C6.37,8.58 7.44,7.48 7.43,6.13C7.43,4.78 6.35,3.67 5.02,3.67C3.7,3.67 2.63,4.76 2.63,6.11zM9.29,0.03L9.3,0.03C9.64,0.03 9.92,0.32 9.92,0.67C9.92,1.02 9.65,1.3 9.31,1.3C9.24,1.3 8.05,1.38 7.05,3.03C8.03,3.7 8.68,4.84 8.68,6.13C8.69,8.19 7.05,9.86 5.04,9.85C3.03,9.84 1.39,8.17 1.38,6.11C1.38,4.85 1.99,3.74 2.92,3.07C1.9,1.35 0.67,1.27 0.61,1.27C0.27,1.26 0,0.97 0,0.62C0,0.27 0.28,0 0.62,0L0.62,0C0.71,0 2.64,0.05 4.05,2.53C4.36,2.44 4.68,2.39 5.02,2.39C5.32,2.39 5.62,2.44 5.9,2.51C7.29,0.06 9.2,0.03 9.29,0.03z' },
    /* 2 Gemini */ { w:8.53,h:10.52, d:'M3.56,2.8L3.55,7.72C3.78,7.7 4.02,7.69 4.28,7.69C4.52,7.69 4.75,7.7 4.97,7.71L4.98,2.84C4.96,2.84 4.94,2.84 4.92,2.84C4.79,2.85 4.67,2.85 4.53,2.85C4.18,2.85 3.86,2.83 3.56,2.8zM6.18,2.71L6.17,7.85C6.81,8.02 7.33,8.29 7.7,8.65C8.27,9.21 8.29,9.79 8.29,9.9C8.28,10.24 8,10.52 7.65,10.52L7.64,10.52C7.29,10.52 7.01,10.23 7.02,9.89C6.99,9.55 6.37,8.87 4.24,8.88C2.05,8.89 1.34,9.61 1.27,9.99C1.21,10.32 0.89,10.55 0.55,10.51C0.21,10.47 -0.03,10.19 0,9.86C0.01,9.79 0.18,8.42 2.26,7.87L2.27,2.59C0.4,2.01 0.26,0.75 0.25,0.68C0.22,0.34 0.47,0.04 0.82,0.01C1.17,-0.03 1.47,0.21 1.51,0.54C1.58,0.92 2.3,1.65 4.48,1.64C6.61,1.63 7.23,0.95 7.26,0.59C7.29,0.26 7.58,-0.01 7.92,0C8.26,0.01 8.53,0.27 8.53,0.6C8.53,0.71 8.51,1.29 7.94,1.85C7.53,2.26 6.93,2.54 6.18,2.71z' },
    /* 3 Cancer */ { w:9.75,h:8.65, d:'M2.24,6.85C1.74,6.85 1.33,6.44 1.33,5.94C1.33,5.44 1.73,5.04 2.23,5.04C2.73,5.04 3.14,5.45 3.14,5.95C3.14,6.45 2.74,6.85 2.24,6.85zM8.53,5.49C8.5,5.51 6.39,7.36 4.01,7.3C4.3,6.93 4.47,6.47 4.47,5.96C4.46,4.73 3.45,3.72 2.22,3.71C0.99,3.7 -0.01,4.7 0,5.93C0.01,7.03 0.81,7.94 1.86,8.13C2.63,8.49 3.39,8.64 4.13,8.64C6.96,8.66 9.3,6.59 9.42,6.48C9.69,6.24 9.72,5.81 9.47,5.54C9.22,5.26 8.8,5.25 8.53,5.49zM7.51,1.8C8.01,1.8 8.42,2.2 8.42,2.7C8.42,3.2 8.02,3.6 7.52,3.6C7.02,3.6 6.61,3.19 6.61,2.69C6.61,2.19 7.01,1.8 7.51,1.8zM1.22,3.16C1.28,3.11 3.38,1.28 5.74,1.34C5.45,1.71 5.28,2.18 5.28,2.69C5.29,3.92 6.3,4.92 7.53,4.93C8.76,4.94 9.76,3.94 9.75,2.71C9.74,1.61 8.94,0.7 7.89,0.51C7.12,0.15 6.36,0 5.62,0C2.79,-0.02 0.44,2.06 0.32,2.17C0.05,2.41 0.03,2.83 0.28,3.1C0.53,3.38 0.95,3.4 1.22,3.16z' },
    /* 4 Leo */ { w:9.09,h:10.37, d:'M2.4,5.11C1.83,5.11 1.37,5.6 1.37,6.2C1.37,6.8 1.83,7.28 2.4,7.28C2.97,7.28 3.44,6.79 3.44,6.19C3.44,5.59 2.97,5.11 2.4,5.11zM3.87,0.45C4.65,-0.11 5.64,-0.14 6.8,0.35C7.57,0.7 8.07,1.28 8.25,2.05C8.72,3.99 7.04,6.53 6.29,7.54C5.95,8 5.99,9.01 6.51,9.26C7.03,9.51 7.77,8.47 7.75,8.38C7.68,7.99 7.92,7.61 8.29,7.53C8.66,7.45 9.01,7.7 9.09,8.09C9.27,9.05 8.55,9.88 7.88,10.31C7.45,10.58 6.36,10.84 5.64,10.37C4.43,9.32 4.27,7.95 5.21,6.67C6.47,4.97 7.14,3.3 6.93,2.41C6.88,2.2 6.75,1.89 6.27,1.67C5.57,1.37 5.02,1.36 4.64,1.63C3.95,2.13 3.77,3.5 3.76,4.11C4.39,4.57 4.8,5.33 4.8,6.19C4.8,7.58 3.71,8.72 2.39,8.72C1.07,8.72 0,7.59 0,6.2C0,4.81 1.09,3.67 2.41,3.67L2.42,3.67C2.49,2.81 2.78,1.24 3.87,0.45z' },
    /* 5 Virgo */ { w:10.34,h:9.22, d:'M8.2,6.66C8.72,6.13 9.14,5.48 9.26,4.76C9.37,4.05 9.04,3.65 8.82,3.47C8.58,3.27 8.33,3.21 8.2,3.2L8.2,6.66zM4.02,0C4.45,0 4.89,0.17 5.22,0.49L5.23,0.49C5.54,0.18 5.96,0.01 6.41,0.01C7.09,0.01 8.17,0.23 8.17,1.54L8.17,2.04C8.58,2.04 9.04,2.19 9.44,2.49C10.2,3.06 10.56,3.98 10.4,4.96C10.22,6.05 9.6,6.95 8.85,7.65C9.14,7.73 9.48,7.8 9.81,7.85C10.13,7.9 10.34,8.2 10.3,8.52C10.26,8.84 9.96,9.05 9.65,9.01C9.22,8.95 8.38,8.79 7.76,8.47C7.1,8.87 6.46,9.12 6,9.21C5.96,9.22 5.92,9.22 5.89,9.22C5.62,9.22 5.37,9.03 5.32,8.75C5.26,8.43 5.47,8.13 5.78,8.07C6.12,8.01 6.58,7.82 7.05,7.54C7.05,7.19 7.02,1.88 7.02,1.88C7.02,1.36 6.7,1.17 6.42,1.17C6.29,1.17 5.86,1.22 5.86,1.87L5.87,6.88C5.87,7.2 5.62,7.46 5.3,7.46C4.98,7.46 4.72,7.2 4.72,6.88C4.72,6.85 4.72,2.9 4.72,1.96C4.72,1.2 4.25,1.17 4.11,1.17C3.97,1.17 3.47,1.22 3.47,1.87L3.48,6.88C3.48,7.2 3.22,7.46 2.9,7.46C2.58,7.46 2.32,7.19 2.32,6.87L2.31,1.94C2.31,1.42 1.99,1.24 1.71,1.24C1.58,1.24 1.16,1.29 1.16,1.94C1.16,2.26 0.9,2.52 0.58,2.52C0.26,2.52 0,2.25 0,1.93C0,1.22 0.28,0.79 0.52,0.55C0.83,0.24 1.26,0.07 1.71,0.07C2.1,0.07 2.51,0.22 2.83,0.49L2.83,0.48C3.14,0.17 3.57,0 4.02,0z' },
    /* 6 Libra */ { w:11.3,h:7.43, d:'M5.57,0C7.3,0.01 8.11,0.95 8.47,1.73C8.72,2.27 8.81,2.82 8.84,3.26L10.65,3.27C11,3.27 11.29,3.56 11.29,3.91C11.29,4.26 11.01,4.53 10.66,4.53L8.24,4.52C7.89,4.52 7.61,4.24 7.61,3.89C7.61,3.56 7.6,2.84 7.33,2.25C7.02,1.58 6.46,1.26 5.58,1.26C4.97,1.26 4.54,1.4 4.24,1.7C3.69,2.26 3.7,3.26 3.71,3.74L3.71,3.86C3.71,4.21 3.44,4.49 3.09,4.49L0.63,4.47C0.28,4.47 0,4.19 0,3.84C0,3.49 0.28,3.22 0.63,3.22L2.46,3.23C2.49,2.53 2.63,1.53 3.34,0.81C3.88,0.27 4.63,-0.01 5.57,0zM10.67,6.18C11.02,6.18 11.3,6.46 11.3,6.81C11.3,7.16 11.03,7.43 10.68,7.43L0.65,7.38C0.3,7.38 0.02,7.1 0.02,6.75C0.02,6.4 0.29,6.12 0.64,6.12L10.67,6.18z' },
    /* 7 Scorpio */ { w:11.19,h:8.43, d:'M11.15,6.22L9.55,5.09C9.41,4.99 9.22,4.98 9.07,5.06C8.92,5.14 8.82,5.29 8.82,5.46L8.82,6.16C8.51,6.09 8.11,5.93 8.11,5.69L8.11,1.49C8.11,0.47 7.04,0 6.37,0C5.92,0 5.5,0.17 5.19,0.47C4.86,0.16 4.43,0 4,0C3.55,0 3.12,0.17 2.81,0.47L2.81,0.48C2.49,0.22 2.09,0.08 1.7,0.08C1.25,0.08 0.83,0.25 0.52,0.55C0.28,0.78 0,1.2 0,1.89C0,2.2 0.25,2.45 0.57,2.45C0.89,2.45 1.15,2.2 1.15,1.89C1.15,1.26 1.57,1.21 1.7,1.21C1.97,1.21 2.29,1.39 2.29,1.89L2.29,6.67C2.29,6.98 2.55,7.24 2.87,7.24C3.19,7.24 3.44,6.98 3.44,6.67L3.44,1.81C3.44,1.18 3.87,1.13 4,1.13C4.78,1.13 4.67,1.87 4.67,2.09L4.67,6.67C4.67,6.98 4.92,7.24 5.24,7.24C5.56,7.24 5.82,6.98 5.82,6.67L5.82,1.81C5.82,1.18 6.24,1.13 6.37,1.13C6.64,1.13 6.96,1.31 6.96,1.81L6.96,5.69C6.96,6.77 8.07,7.21 8.82,7.31L8.82,7.97C8.82,8.15 8.93,8.32 9.09,8.39C9.15,8.42 9.21,8.43 9.28,8.43C9.39,8.43 9.5,8.38 9.59,8.31L11.19,6.94C11.3,6.85 11.35,6.71 11.34,6.57C11.33,6.43 11.26,6.3 11.15,6.22z' },
    /* 8 Sagittarius */ { w:9.92,h:9.84, d:'M9.91,0.62C9.91,0.55 9.9,0.47 9.87,0.4C9.84,0.32 9.79,0.26 9.73,0.2L9.73,0.19C9.67,0.13 9.6,0.08 9.52,0.05C9.44,0.02 9.35,0 9.27,0L5.81,0C5.45,0 5.16,0.29 5.16,0.65C5.16,1.01 5.45,1.29 5.81,1.29L7.7,1.29L4.6,4.36L3.49,3.21C3.24,2.95 2.83,2.95 2.57,3.2C2.31,3.45 2.3,3.85 2.55,4.11L3.68,5.27L0.19,8.74C-0.06,8.99 -0.06,9.4 0.19,9.65C0.32,9.78 0.48,9.84 0.65,9.84C0.82,9.84 0.98,9.78 1.11,9.65L4.58,6.2L5.86,7.52C5.99,7.65 6.16,7.72 6.33,7.72C6.49,7.72 6.65,7.65 6.77,7.53C7.03,7.28 7.04,6.88 6.79,6.62L5.5,5.29L8.62,2.2L8.62,4.03C8.62,4.39 8.91,4.68 9.27,4.68C9.63,4.68 9.92,4.39 9.92,4.03L9.92,0.65C9.92,0.64 9.91,0.63 9.91,0.62z' },
    /* 9 Capricorn */ { w:11.28,h:9.15, d:'M7.57,5.12C7.57,5.91 8.16,6.55 8.89,6.55C9.63,6.55 10.24,5.9 10.24,5.11C10.24,4.32 9.65,3.67 8.91,3.67C8.18,3.67 7.57,4.33 7.57,5.12zM7.01,3.6C7.45,2.97 8.14,2.54 8.92,2.54C10.23,2.53 11.29,3.68 11.28,5.1C11.27,6.52 10.2,7.67 8.89,7.68C8.34,7.68 7.84,7.48 7.44,7.15C6.9,7.92 5.78,9.1 3.99,9.15L3.98,9.15C3.7,9.15 3.46,8.91 3.46,8.6C3.46,8.29 3.69,8.03 3.98,8.02C5.54,7.98 6.44,6.77 6.76,6.24C6.61,5.9 6.52,5.53 6.52,5.13L6.53,5.06L6.53,5.01C6.26,4.58 5.53,3.28 5.54,1.65C5.54,1.51 5.49,1.42 5.39,1.35C5.26,1.26 5.06,1.21 4.83,1.21C4.33,1.21 3.9,1.46 3.9,1.66L3.88,6.27C3.88,6.58 3.64,6.84 3.35,6.84C3.06,6.84 2.83,6.59 2.83,6.28L2.86,1.66C2.81,1.47 2.09,1.04 1.47,1.14C1.12,1.2 1.05,1.39 1.05,1.67C1.05,1.98 0.81,2.24 0.52,2.24C0.23,2.24 0,1.99 0,1.68C0,0.99 0.3,0.59 0.54,0.38C0.83,0.14 1.21,0 1.65,0C2.2,0 2.88,0.22 3.35,0.6C3.74,0.26 4.3,0.07 4.84,0.07C5.89,0.06 6.6,0.7 6.59,1.64C6.59,2.41 6.8,3.1 7.01,3.6z' },
    /* 10 Aquarius */ { w:11.26,h:6.83, d:'M9.33,4.95C9.75,4.48 10.14,4.03 10.67,4.03C10.99,4.03 11.25,4.29 11.25,4.61C11.25,4.91 11.02,5.16 10.72,5.18C10.6,5.24 10.35,5.52 10.18,5.71L10.18,5.72C9.72,6.24 9.19,6.83 8.49,6.83C7.77,6.83 7.4,6.23 7.1,5.74L7.1,5.74L7.09,5.74C6.93,5.48 6.72,5.13 6.57,5.13C6.48,5.13 6.34,5.39 6.23,5.6C5.98,6.08 5.59,6.82 4.67,6.82C3.78,6.82 3.37,6.11 3.1,5.63C2.87,5.22 2.76,5.07 2.63,5.07C2.37,5.07 2.17,5.29 1.86,5.67C1.55,6.05 1.17,6.52 0.57,6.52C0.25,6.52 0,6.26 0,5.94C0,5.62 0.26,5.36 0.57,5.36C0.66,5.33 0.86,5.1 0.98,4.95L0.98,4.94C1.33,4.51 1.82,3.91 2.63,3.91C3.45,3.91 3.83,4.56 4.1,5.04L4.1,5.05C4.36,5.51 4.48,5.66 4.68,5.66C4.87,5.66 4.96,5.56 5.22,5.07L5.22,5.06C5.45,4.62 5.79,3.97 6.57,3.97C7.35,3.97 7.77,4.63 8.07,5.12L8.07,5.13C8.18,5.31 8.4,5.65 8.5,5.67C8.69,5.67 9.1,5.2 9.33,4.95zM1.87,1.76C1.56,2.14 1.18,2.61 0.58,2.61C0.26,2.61 0.01,2.35 0.01,2.03C0.01,1.71 0.27,1.45 0.58,1.45C0.67,1.42 0.86,1.19 0.98,1.04L0.99,1.03C1.34,0.6 1.84,0 2.65,0C3.47,0 3.84,0.65 4.11,1.13L4.11,1.13C4.37,1.59 4.49,1.75 4.69,1.75C4.88,1.75 4.97,1.64 5.23,1.15L5.23,1.15C5.46,0.72 5.8,0.06 6.58,0.06C7.36,0.06 7.78,0.72 8.08,1.21L8.09,1.22C8.2,1.4 8.41,1.74 8.51,1.76C8.7,1.76 9.12,1.28 9.35,1.03C9.77,0.56 10.16,0.12 10.69,0.12C11.01,0.12 11.26,0.37 11.26,0.69C11.26,0.99 11.03,1.25 10.73,1.27C10.61,1.33 10.37,1.61 10.2,1.8L10.19,1.81C9.73,2.33 9.21,2.92 8.51,2.92C7.79,2.92 7.41,2.31 7.11,1.83L7.11,1.83L7.11,1.83C6.95,1.57 6.73,1.22 6.58,1.22C6.49,1.22 6.35,1.48 6.24,1.69C5.99,2.17 5.61,2.91 4.69,2.91C3.8,2.91 3.39,2.19 3.12,1.71C2.89,1.3 2.77,1.16 2.64,1.16C2.38,1.16 2.18,1.38 1.87,1.76z' },
    /* 11 Pisces */ { w:9.83,h:9.93, d:'M9.16,4.59L6.83,4.59C7.05,2.27 8.24,1.39 8.31,1.34C8.62,1.13 8.72,0.69 8.53,0.35C8.34,0.01 7.93,-0.11 7.61,0.1C7.53,0.15 5.72,1.39 5.48,4.59L3.98,4.59C3.74,1.39 1.93,0.15 1.85,0.1C1.54,-0.11 1.13,0 0.94,0.34C0.75,0.68 0.84,1.13 1.15,1.34C1.21,1.38 2.42,2.25 2.64,4.59L0.67,4.59C0.3,4.59 0,4.91 0,5.31C0,5.71 0.3,6.04 0.67,6.04L2.63,6.04C2.41,8.11 1.26,8.49 1.21,8.5C0.85,8.59 0.62,8.99 0.71,9.38C0.78,9.71 1.06,9.93 1.36,9.93C1.41,9.93 1.47,9.92 1.52,9.91C1.61,9.88 3.71,9.31 3.98,6.04L5.49,6.04C5.76,9.31 7.85,9.88 7.94,9.91C7.99,9.92 8.05,9.93 8.1,9.93C8.4,9.93 8.66,9.72 8.74,9.39C8.83,9.01 8.62,8.62 8.27,8.51C8.22,8.49 7.05,8.11 6.83,6.04L9.16,6.04C9.53,6.04 9.83,5.71 9.83,5.31C9.83,4.91 9.53,4.59 9.16,4.59z' }
  ];

  /* ══════════════════════════════════════════════════════════════
     PLANET GLYPHS — Astroline-style filled paths.
     Uranus & Neptune: hand-drawn stroked fallbacks (16×16 box).
     ══════════════════════════════════════════════════════════════ */
  var PLANET_DATA = {
    Sun: { w:7.67,h:7.67, d:'M7.67,3.83 C7.67,5.95 5.95,7.67 3.83,7.67 C1.71,7.67 0,5.95 0,3.83 C0,1.71 1.71,0 3.83,0 C5.95,0 7.67,1.71 7.67,3.83z M5,3.83 C5,4.47 4.47,5 3.83,5 C3.19,5 2.67,4.47 2.67,3.83 C2.67,3.19 3.19,2.67 3.83,2.67 C4.47,2.67 5,3.19 5,3.83z M4,3.83 C4,3.74 3.92,3.67 3.83,3.67 C3.74,3.67 3.67,3.74 3.67,3.83 C3.67,3.92 3.74,4 3.83,4 C3.92,4 4,3.92 4,3.83z M6.67,3.83 C6.67,2.27 5.39,1 3.83,1 C2.27,1 1,2.27 1,3.83 C1,5.39 2.27,6.67 3.83,6.67 C5.39,6.67 6.67,5.39 6.67,3.83z' },
    Moon: { w:6,h:7.1, d:'M4.19,1.03 C3.35,0.91 2.47,1.17 1.82,1.83 C0.73,2.94 0.73,4.73 1.82,5.84 C2.47,6.5 3.35,6.76 4.19,6.64 C3.92,6.49 3.66,6.3 3.43,6.07 C2.21,4.83 2.21,2.84 3.43,1.6 C3.66,1.37 3.92,1.18 4.19,1.03z M1.11,1.13 C2.37,-0.15 4.3,-0.34 5.76,0.56 L6,0.71 L6,1.64 L5.53,1.67 C5.03,1.7 4.53,1.91 4.14,2.3 C3.3,3.15 3.3,4.52 4.14,5.37 C4.53,5.76 5.03,5.97 5.53,6 L6,6.02 L6,6.96 L5.76,7.1 C4.3,8.01 2.37,7.82 1.11,6.54 C-0.37,5.04 -0.37,2.63 1.11,1.13z' },
    Mercury: { w:6.33,h:7.33, d:'M4.67,1.5 C4.67,2.33 4,3 3.17,3 C2.34,3 1.67,2.33 1.67,1.5 C1.67,0.67 2.34,0 3.17,0 C4,0 4.67,0.67 4.67,1.5z M3.67,1.5 C3.67,1.22 3.45,1 3.17,1 C2.89,1 2.67,1.22 2.67,1.5 C2.67,1.78 2.89,2 3.17,2 C3.45,2 3.67,1.78 3.67,1.5z M2.67,6 L1.33,6 L1.33,5 L2.67,5 L2.67,4.63 C1.16,4.39 0,3.08 0,1.5 L0,1 L1,1 L1,1.5 C1,2.7 1.97,3.67 3.17,3.67 C4.37,3.67 5.33,2.7 5.33,1.5 L5.33,1 L6.33,1 L6.33,1.5 C6.33,3.08 5.18,4.39 3.67,4.63 L3.67,5 L5,5 L5,6 L3.67,6 L3.67,7.33 L2.67,7.33 L2.67,6z' },
    Venus: { w:5,h:7.67, d:'M5,2.5 C5,3.71 4.14,4.72 3,4.95 L3,5.33 L4.33,5.33 L4.33,6.33 L3,6.33 L3,7.67 L2,7.67 L2,6.33 L0.67,6.33 L0.67,5.33 L2,5.33 L2,4.95 C0.86,4.72 0,3.71 0,2.5 C0,1.12 1.12,0 2.5,0 C3.88,0 5,1.12 5,2.5z M4,2.5 C4,1.67 3.33,1 2.5,1 C1.67,1 1,1.67 1,2.5 C1,3.33 1.67,4 2.5,4 C3.33,4 4,3.33 4,2.5z' },
    Mars: { w:7.04,h:7.04, d:'M6,1.75 L4.58,3.16 C4.84,3.56 5,4.03 5,4.54 C5,5.92 3.88,7.04 2.5,7.04 C1.12,7.04 0,5.92 0,4.54 C0,3.16 1.12,2.04 2.5,2.04 C3.01,2.04 3.48,2.19 3.88,2.45 L5.29,1.04 L4,1.04 L4,0.04 L6.29,0.04 L6.33,0 L6.37,0.04 L7,0.04 L7,0.67 L7.04,0.71 L7,0.75 L7,3.04 L6,3.04 L6,1.75z M4,4.54 C4,4.13 3.83,3.75 3.56,3.48 C3.29,3.21 2.91,3.04 2.5,3.04 C1.67,3.04 1,3.71 1,4.54 C1,5.37 1.67,6.04 2.5,6.04 C3.33,6.04 4,5.37 4,4.54z' },
    Jupiter: { w:6.33,h:7.43, d:'M1.17,0 C2.07,0 2.79,0.21 3.27,0.64 C3.77,1.08 3.94,1.7 3.83,2.32 C3.68,3.17 3.01,4.03 1.99,4.67 L3.8,4.67 L4.79,0.24 L5.76,0.45 L5.65,0.94 L4.83,4.67 L6.33,4.67 L6.33,5.67 L4.6,5.67 L4.21,7.43 L3.24,7.21 L3.35,6.72 L3.58,5.67 L0,5.67 L0,4.48 L0.33,4.36 C1.9,3.81 2.72,2.83 2.84,2.14 C2.9,1.82 2.82,1.58 2.61,1.39 C2.38,1.19 1.94,1 1.17,1 L0.67,1 L0.67,0 L1.17,0z' },
    Saturn: { w:7,h:7.33, d:'M6.17,4.67 C6.17,6.14 4.97,7.33 3.5,7.33 C2.03,7.33 0.83,6.14 0.83,4.67 C0.83,3.74 1.31,2.92 2.03,2.44 C1.8,2.23 1.62,2 1.47,1.8 C1.05,1.24 0.87,1 0.5,1 L0,1 L0,0 L0.5,0 C1.46,0 1.95,0.76 2.28,1.2 C2.65,1.69 2.93,2 3.5,2 C4.07,2 4.35,1.69 4.72,1.2 C5.05,0.76 5.54,0 6.5,0 L7,0 L7,1 L6.5,1 C6.13,1 5.95,1.24 5.53,1.8 C5.38,2 5.19,2.23 4.96,2.44 C5.68,2.92 6.17,3.74 6.17,4.67z M5.17,4.67 C5.17,3.75 4.42,3 3.5,3 C2.58,3 1.83,3.75 1.83,4.67 C1.83,5.59 2.58,6.33 3.5,6.33 C4.42,6.33 5.17,5.59 5.17,4.67z' },
    Pluto: { w:5.41,h:7.87, d:'M5.21,3.37 C5.21,4.58 4.35,5.59 3.21,5.82 L3.21,5.87 L4.54,5.87 L4.54,6.87 L3.21,6.87 L3.21,7.87 L2.21,7.87 L2.21,6.87 L0.87,6.87 L0.87,5.87 L2.21,5.87 L2.21,5.82 C1.07,5.59 0.21,4.58 0.21,3.37 C0.21,2.63 0.53,1.97 1.04,1.51 C1.02,1.5 1,1.5 0.98,1.49 C0.78,1.39 0.63,1.29 0.53,1.21 C0.48,1.17 0.44,1.14 0.41,1.11 C0.4,1.1 0.38,1.09 0.37,1.08 L0.36,1.07 L0,0.71 L0.71,0 L1.06,0.35 L1.07,0.36 C1.08,0.37 1.1,0.39 1.13,0.41 C1.19,0.46 1.29,0.52 1.43,0.59 C1.67,0.71 2.03,0.84 2.5,0.87 L2.71,0.87 L2.92,0.87 C3.39,0.84 3.74,0.71 3.98,0.59 C4.12,0.52 4.22,0.46 4.28,0.41 C4.31,0.39 4.34,0.37 4.35,0.36 L4.36,0.35 L4.71,0 L5.41,0.71 L5.05,1.07 L5.04,1.08 C5.03,1.09 5.01,1.1 5,1.11 C4.97,1.14 4.93,1.17 4.88,1.21 C4.78,1.29 4.63,1.39 4.43,1.49 C4.41,1.5 4.39,1.5 4.37,1.51 C4.88,1.97 5.21,2.63 5.21,3.37z M4.21,3.37 C4.21,2.54 3.54,1.87 2.71,1.87 C1.88,1.87 1.21,2.54 1.21,3.37 C1.21,4.2 1.88,4.87 2.71,4.87 C3.54,4.87 4.21,4.2 4.21,3.37z' }
  };

  /* Stroked fallbacks for Uranus, Neptune & Node (no Astroline source) */
  var PLANET_STROKE_FALLBACK = {
    Uranus: 'M8,6 A3,3 0 1,1 8,12 A3,3 0 1,1 8,6 Z M8,6 L8,2 M5,4 L8,2 L11,4 M4,8 L5,8 M11,8 L12,8',
    Neptune: 'M8,5 L8,15 M4,5 L8,1 L12,5 M4,5 L4,7 M12,5 L12,7 M5,8 L11,8',
    Node: 'M4,13 L4,8 A4,4 0 1,1 12,8 L12,13'
  };

  var PLANET_NAMES = ['Sun','Moon','Mercury','Venus','Mars','Jupiter','Saturn','Uranus','Neptune','Pluto','Node'];
  var HOUSE_LABELS = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];

  /* ── Geometry helpers ───────────────────────────────────────── */
  var NS = 'http://www.w3.org/2000/svg';

  function mk(tag, a) {
    var e = document.createElementNS(NS, tag);
    if (a) for (var k in a) if (a.hasOwnProperty(k)) e.setAttribute(k, a[k]);
    return e;
  }

  /* Rotation offset: rotates entire wheel so ASC is at 9 o'clock (left) */
  var CHART_ROT = 0;

  function pol(cx, cy, r, deg) {
    var rad = (90 - deg + CHART_ROT) * Math.PI / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  /* Fixed reference = largest native dimension across all 12 signs.
     All glyphs share ONE scale factor → consistent visual weight
     (same approach as Astroline's matrix transforms). */
  var SIGN_REF = 11.35; // Aries width — the largest bounding-box edge

  /* Fixed reference for planet glyphs (same principle as SIGN_REF). */
  var PLANET_REF = 7.87; // Pluto height — the largest bounding-box edge

  /**
   * Stamp a FILLED sign glyph at (x,y).
   * Uses a fixed reference so all signs keep their native proportions.
   */
  function signGlyph(idx, x, y, size, fill) {
    var data = SIGN_DATA[idx];
    var sc = size / SIGN_REF;
    var g = mk('g', {
      transform: 'translate(' + (x - data.w * sc / 2) + ',' + (y - data.h * sc / 2) + ') scale(' + sc + ')'
    });
    g.appendChild(mk('path', {
      d: data.d,
      fill: fill,
      'fill-rule': 'evenodd'
    }));
    return g;
  }

  /**
   * Stamp a planet glyph at (x,y) by name.
   * Uses Astroline filled paths (PLANET_DATA) when available,
   * falls back to stroked 16×16 paths for Uranus/Neptune.
   */
  function planetGlyph(name, x, y, size, color) {
    var data = PLANET_DATA[name];
    if (data) {
      var sc = size / PLANET_REF;
      var g = mk('g', {
        transform: 'translate(' + (x - data.w * sc / 2) + ',' + (y - data.h * sc / 2) + ') scale(' + sc + ')'
      });
      g.appendChild(mk('path', {
        d: data.d,
        fill: color,
        'fill-rule': 'evenodd'
      }));
      return g;
    }
    /* Stroked fallback (Uranus, Neptune) — 16×16 viewBox */
    var fb = PLANET_STROKE_FALLBACK[name];
    if (fb) {
      var sc2 = size / 16;
      var g2 = mk('g', {
        transform: 'translate(' + (x - size / 2) + ',' + (y - size / 2) + ') scale(' + sc2 + ')'
      });
      g2.appendChild(mk('path', {
        d: fb,
        fill: 'none',
        stroke: color,
        'stroke-width': 1.3 / sc2,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      }));
      return g2;
    }
    return mk('g');
  }

  function spread(items, r, cx, cy, gap) {
    var arr = items.map(function(p, i) { return { idx: i, name: p.name, angle: p.lon }; });
    arr.sort(function(a, b) { return a.angle - b.angle; });
    for (var pass = 0; pass < 10; pass++) {
      var moved = false;
      for (var j = 1; j < arr.length; j++) {
        var d = arr[j].angle - arr[j - 1].angle;
        if (d < gap) { var push = (gap - d) / 2; arr[j - 1].angle -= push; arr[j].angle += push; moved = true; }
      }
      if (!moved) break;
    }
    return arr.map(function(o) {
      var p = pol(cx, cy, r, o.angle);
      return { idx: o.idx, name: o.name, angle: o.angle, x: p.x, y: p.y };
    });
  }

  /* ── Palette (cream background — site colors, full opacity) ── */
  var C_LIGHT = {
    ring:      '#C4B8D6',                      /* circles — light violet        */
    signDiv:   '#7A66A3',                      /* sign separators — dark violet */
    txt:       '#6B4E9E',                      /* sign glyphs — violet          */
    bright:    '#2D1B4E',                      /* main cusps (Asc/Dsc lines)    */
    dimLine:   '#C4B8D6',                      /* secondary cusps — lighter     */
    faintLine: '#D6CCDF',                      /* minor cusps — very light      */
    tick:      '#D6CCDF',                      /* degree ticks                  */
    red:       'rgba(195,60,60,0.7)',          /* hard aspects — clearer red    */
    cyan:      'rgba(55,145,185,0.65)',        /* soft aspects — clearer blue   */
    minor:     'rgba(130,110,160,0.4)',        /* minor aspects — subtle purple */
    dot:       '#2D1B4E',                      /* planet dots — ink             */
    label:     '#4A3366',                      /* planet glyphs — ink-light     */
    labelBold: '#2D1B4E'                       /* Sun/Moon glyphs — ink         */
  };

  /* ── Dark palette (midnight background) ── */
  var C_DARK = {
    ring:      'rgba(255,255,255,0.4)',         /* main ring — more visible      */
    signDiv:   'rgba(255,255,255,0.45)',        /* sign dividers — more visible  */
    txt:       'rgba(251,212,132,0.9)',         /* gold glyphs — brighter        */
    bright:    'rgba(255,255,255,0.7)',         /* Asc/Dsc lines — bold          */
    dimLine:   'rgba(255,255,255,0.3)',         /* secondary cusps — visible     */
    faintLine: 'rgba(255,255,255,0.18)',        /* minor cusps — subtle but seen */
    tick:      'rgba(255,255,255,0.2)',         /* degree ticks                  */
    red:       'rgba(210,70,70,0.75)',          /* hard aspects — stronger       */
    cyan:      'rgba(65,160,195,0.75)',         /* soft aspects — stronger       */
    minor:     'rgba(180,160,220,0.45)',        /* minor aspects — subtle purple */
    dot:       'rgba(255,255,255,0.9)',         /* planet dots — bright          */
    label:     'rgba(255,255,255,0.75)',        /* planet glyphs — brighter      */
    labelBold: 'rgba(255,255,255,0.95)'        /* Sun/Moon glyphs — near white  */
  };

  var C = C_LIGHT;

  /* ═══════════════════════════════════════════════════════════════ */
  function NatalWheel(container, chartData, opts) {
    opts = opts || {};
    this.el = container; this.d = chartData;
    this.sz = opts.size || 320;
    this.anim = opts.animate !== false;
    this.spd = opts.speed || 1.0;
    this.mini = !!opts.mini;
    this.noTime = !!opts.unknownTime;
    this.C = opts.dark ? C_DARK : C_LIGHT;

    /* Rotate wheel so ASC is at 9 o'clock (left), standard in Western astrology */
    var ascLon = (chartData.ascendant && !this.noTime) ? chartData.ascendant.longitude : 0;
    CHART_ROT = ascLon + 90;

    var s = this.sz; this.cx = s / 2; this.cy = s / 2;
    if (this.mini) {
      this.rO = s/2-6; this.rH = this.rO-12; this.rSO = this.rH; this.rSI = this.rSO-16; this.rP = this.rSI;
    } else {
      this.rO = s/2-10; this.rH = this.rO-18; this.rSO = this.rH; this.rSI = this.rSO-26; this.rP = this.rSI;
    }

    this.hc = [];
    if (chartData.ascendant && !this.noTime) {
      if (chartData.houseCusps && chartData.houseCusps.length === 12) {
        // Use real Placidus house cusps from the calculation engine
        for (var i = 0; i < 12; i++) this.hc.push(chartData.houseCusps[i]);
      } else {
        // Fallback to equal houses
        var aL = chartData.ascendant.longitude;
        for (var i = 0; i < 12; i++) this.hc.push((aL + i * 30) % 360);
      }
    }

    this.pl = [];
    for (var j = 0; j < PLANET_NAMES.length; j++) {
      var p = chartData.planets[PLANET_NAMES[j]];
      if (p) this.pl.push({ name: PLANET_NAMES[j], lon: p.longitude });
    }
    this.pp = spread(this.pl, this.rP, this.cx, this.cy, this.mini ? 7 : 9);

    var aspects = (chartData.aspects || []).slice().sort(function(a, b) { return a.orb - b.orb; });
    this.asp = aspects.slice(0, this.mini ? 12 : 50);
  }

  NatalWheel.prototype.render = function() {
    C = this.C;
    var svg = mk('svg', {
      width: this.sz, height: this.sz,
      viewBox: '0 0 ' + this.sz + ' ' + this.sz,
      class: 'as-natal-wheel',
      style: 'display:block;margin:0 auto;width:100%;height:auto;'
    });
    svg.appendChild(mk('circle', { cx: this.cx, cy: this.cy, r: this.rO + 2, fill: 'transparent' }));

    if (this.anim && !this.mini) { this._anim(svg); }
    else { this._phase1(svg,1); this._phase2(svg,1); this._allAspects(svg); this._planets(svg,1); }

    this.el.innerHTML = ''; this.el.appendChild(svg);
  };

  NatalWheel.prototype._anim = function(svg) {
    var self = this;
    var sp = this.spd;
    function fadeIn(fn, delay, dur) {
      setTimeout(function() {
        var g = fn.call(self, svg, 0);
        g.style.transition = 'opacity ' + ((dur||1.2)*sp).toFixed(2) + 's ease';
        requestAnimationFrame(function() { g.style.opacity = '1'; });
      }, Math.round(delay * sp));
    }
    fadeIn(self._phase1, 500, 1.2);
    fadeIn(self._phase2, 1800, 1.2);
    var asp = this.asp;
    for (var i = 0; i < asp.length; i++) {
      (function(idx) {
        setTimeout(function() {
          var line = self._mkAspect(asp[idx]);
          if (!line) return;
          line.style.opacity = '0';
          line.style.transition = 'opacity ' + (0.6*sp).toFixed(2) + 's ease';
          svg.appendChild(line);
          requestAnimationFrame(function() { line.style.opacity = '1'; });
        }, Math.round((3000 + idx * 280) * sp));
      })(i);
    }
    var t4 = Math.round((3000 + asp.length * 280 + 500) * sp);
    setTimeout(function() {
      var g = self._planets(svg, 0);
      g.style.transition = 'opacity ' + (1.0*sp).toFixed(2) + 's ease';
      requestAnimationFrame(function() { g.style.opacity = '1'; });
      if (typeof CustomEvent !== 'undefined') self.el.dispatchEvent(new CustomEvent('wheelComplete'));
    }, t4);
  };

  /* Phase 1: rings, divisions, ticks */
  NatalWheel.prototype._phase1 = function(svg, op) {
    var g = mk('g', { opacity: op }); var cx = this.cx, cy = this.cy;
    g.appendChild(mk('circle', { cx:cx,cy:cy,r:this.rO, fill:'none',stroke:C.ring,'stroke-width':'1' }));
    g.appendChild(mk('circle', { cx:cx,cy:cy,r:this.rH, fill:'none',stroke:C.signDiv,'stroke-width':'0.6' }));
    g.appendChild(mk('circle', { cx:cx,cy:cy,r:this.rSI,fill:'none',stroke:C.signDiv,'stroke-width':'0.8' }));
    for (var s = 0; s < 12; s++) {
      var a = s*30, p1 = pol(cx,cy,this.rSO,a), p2 = pol(cx,cy,this.rSI,a);
      g.appendChild(mk('line', { x1:p1.x,y1:p1.y,x2:p2.x,y2:p2.y,stroke:C.signDiv,'stroke-width':'0.8' }));
    }
    for (var h = 0; h < this.hc.length; h++) {
      var ha = this.hc[h], h1 = pol(cx,cy,this.rO,ha), h2 = pol(cx,cy,this.rSI,ha);
      var main = (h===0||h===6), sec = (h===3||h===9);
      g.appendChild(mk('line', { x1:h1.x,y1:h1.y,x2:h2.x,y2:h2.y,
        stroke:main?C.bright:sec?C.dimLine:C.faintLine, 'stroke-width':main?'1.2':sec?'0.7':'0.5' }));
    }
    if (!this.mini) {
      for (var t = 0; t < 72; t++) {
        var ta = t*5; if (ta%30===0) continue;
        var isTen = (ta%10===0), t1 = pol(cx,cy,this.rSO,ta), t2 = pol(cx,cy,this.rSO-(isTen?4:2),ta);
        g.appendChild(mk('line', { x1:t1.x,y1:t1.y,x2:t2.x,y2:t2.y,stroke:C.tick,'stroke-width':'0.3' }));
      }
    }
    svg.appendChild(g); return g;
  };

  /* Phase 2: sign glyphs, house labels, Asc/Dsc */
  NatalWheel.prototype._phase2 = function(svg, op) {
    var g = mk('g', { opacity: op }); var cx = this.cx, cy = this.cy;
    var glSz = this.mini ? 10 : 16;
    for (var i = 0; i < 12; i++) {
      var mid = i*30+15, p = pol(cx,cy,(this.rSO+this.rSI)/2, mid);
      g.appendChild(signGlyph(i, p.x, p.y, glSz, C.txt));
    }
    if (this.hc.length && !this.mini) {
      var hLabels = [];
      for (var h = 0; h < 12; h++) {
        var next = this.hc[(h+1)%12], cur = this.hc[h], diff = next-cur; if (diff<0) diff+=360;
        var midH = (cur+diff/2)%360, hp = pol(cx,cy,(this.rO+this.rH)/2,midH);
        hLabels.push({ x: hp.x, y: hp.y, label: HOUSE_LABELS[h], size: diff < 15 ? 6 : 8 });
      }
      /* Anti-overlap: nudge labels that are too close */
      for (var h1 = 0; h1 < hLabels.length; h1++) {
        for (var h2 = h1+1; h2 < hLabels.length; h2++) {
          var dx = hLabels[h2].x - hLabels[h1].x, dy = hLabels[h2].y - hLabels[h1].y;
          var dist = Math.sqrt(dx*dx+dy*dy);
          if (dist < 10) {
            var nudge = (10-dist)/2+1;
            hLabels[h1].y -= nudge;
            hLabels[h2].y += nudge;
          }
        }
      }
      for (var h = 0; h < hLabels.length; h++) {
        var hl = hLabels[h];
        var ht = mk('text', { x:hl.x,y:hl.y+1,'text-anchor':'middle','dominant-baseline':'central',
          fill:C.label,'font-size':String(hl.size),'font-family':'Georgia,serif','letter-spacing':'0.5' });
        ht.textContent = hl.label; g.appendChild(ht);
      }
      var ascA = this.hc[0], dscA = this.hc[6];
      var mcA = this.hc[9], icA = this.hc[3];
      var aP = pol(cx,cy,this.rO+3,ascA), dP = pol(cx,cy,this.rO+3,dscA);
      var mP = pol(cx,cy,this.rO+3,mcA), iP = pol(cx,cy,this.rO+3,icA);
      var aT = mk('text', { x:aP.x,y:aP.y,'text-anchor':'middle','dominant-baseline':'central',
        fill:C.bright,'font-size':'8','font-family':'Georgia,serif','font-style':'italic' });
      aT.textContent = 'Asc'; g.appendChild(aT);
      var dT = mk('text', { x:dP.x,y:dP.y,'text-anchor':'middle','dominant-baseline':'central',
        fill:C.label,'font-size':'7.5','font-family':'Georgia,serif','font-style':'italic' });
      dT.textContent = 'Dsc'; g.appendChild(dT);
      var mT = mk('text', { x:mP.x,y:mP.y,'text-anchor':'middle','dominant-baseline':'central',
        fill:C.label,'font-size':'7','font-family':'Georgia,serif','font-style':'italic' });
      mT.textContent = 'MC'; g.appendChild(mT);
      var iT = mk('text', { x:iP.x,y:iP.y,'text-anchor':'middle','dominant-baseline':'central',
        fill:C.txt,'font-size':'7','font-family':'Georgia,serif','font-style':'italic' });
      iT.textContent = 'IC'; g.appendChild(iT);
    }
    svg.appendChild(g); return g;
  };

  /* Phase 3: aspects */
  NatalWheel.prototype._mkAspect = function(a) {
    var p1=null,p2=null;
    for (var i=0;i<this.pp.length;i++) {
      if (this.pp[i].name===a.planet1) p1=this.pp[i];
      if (this.pp[i].name===a.planet2) p2=this.pp[i];
    }
    if (!p1||!p2) return null;
    var color = a.type==='hard'?C.red:a.type==='minor'?C.minor:C.cyan;
    var sw;
    if (a.type==='minor') { sw = 0.4; }
    else if (a.orb < 1) { sw = 1.4; }
    else if (a.orb < 3) { sw = 1.1; }
    else if (a.orb < 5) { sw = 0.8; }
    else { sw = 0.6; }
    var attrs = { x1:p1.x,y1:p1.y,x2:p2.x,y2:p2.y,stroke:color,'stroke-width':String(sw) };
    if (a.type==='minor') attrs['stroke-dasharray'] = '3,3';
    else if (a.orb > 6) attrs['stroke-dasharray'] = '2,2';
    return mk('line', attrs);
  };
  NatalWheel.prototype._allAspects = function(svg) {
    var g = mk('g');
    for (var i=0;i<this.asp.length;i++) { var l=this._mkAspect(this.asp[i]); if(l) g.appendChild(l); }
    svg.appendChild(g);
  };

  /* Phase 4: planet dots + filled glyph labels */
  NatalWheel.prototype._planets = function(svg, op) {
    var g = mk('g', { opacity: op }); var pp = this.pp;
    var lr = this.rP - (this.mini ? 8 : 14);
    var dR = this.mini ? 2.5 : 2.5;
    var gSz = this.mini ? 7 : 9, gSzB = this.mini ? 9 : 11;
    for (var i = 0; i < pp.length; i++) {
      var p = pp[i], big = (p.idx < 2);
      g.appendChild(mk('circle', { cx:p.x,cy:p.y,r:big?3:dR,fill:C.dot }));
      var lp = pol(this.cx,this.cy,lr,p.angle);
      g.appendChild(planetGlyph(p.name, lp.x, lp.y, big?gSzB:gSz, big?C.labelBold:C.label));
    }
    svg.appendChild(g); return g;
  };

  global.NatalWheel = NatalWheel;
  global.NatalWheel.SIGN_DATA = SIGN_DATA;
  global.NatalWheel.SIGN_REF = SIGN_REF;
})(typeof window !== 'undefined' ? window : this);
